import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PostsService } from '../posts.service';
import { DomSanitizer, Title, SafeResourceUrl } from '@angular/platform-browser';
import * as PrismicDOM from 'prismic-dom';
import * as _ from 'lodash';

function youtubeParser(url){
  var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
  var match = url.match(regExp);
  return (match&&match[7].length==11)? match[7] : false;
}

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.css']
})
export class VideoComponent implements OnInit {

  public post;
  public loading: boolean;
  public relatedPosts = [];
  public embedUrl:SafeResourceUrl;

  generateMarkup(data) {
    return PrismicDOM.RichText.asHtml(data);
  }

  getPost(id): void {
    this.posts.getPost('post', id).subscribe((posts) => {
      let post = _.first(posts);
      this.post = post.data;
      this.loading = false;
      console.log("VIDEO: ", post);
      this.titleService.setTitle((this.post.title && this.post.title[0] ? this.post.title[0].text + ' -- ' : '') + "Bender Hardware Videos");
      if (post.data.related_posts) {
        this.relatedPosts = _.filter(post.data.related_posts, (p)=>p.post && p.post.data);
      }
      console.log("RELATED POSTS: ", this.relatedPosts);

      if (this.post && _.has(this.post, ['video', 'url'])) {
        let url = this.post.video.url;
        if (url.indexOf('youtu') > -1 && url.indexOf('/embed') < 0) {
          let id = youtubeParser(url);
          url = 'https://www.youtube.com/embed/' + id
        } 
        this.embedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      } return null;
      
    });
  }

  public getThumb (vid) {
    return vid.featured_image.Thumbnail ? vid.featured_image.Thumbnail.url : vid.featured_image.url;
  }

  // getEmbed() {
  //   if (this.post && _.has(this.post, ['video', 'url'])) {
  //     console.log(this.post.video.url);
  //     let url = this.post.video.url;
  //     if (url.indexOf('youtu') > -1 && url.indexOf('/embed') < 0) {
  //       let id = youtubeParser(url);
  //       url = 'https://www.youtube.com/embed/' + id
  //     } 
  //     return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  //   } return null;

  // }

  constructor(private route: ActivatedRoute, private sanitizer: DomSanitizer, private posts: PostsService, private titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle("Videos -- Bender Hardware");

    this.loading = true;
    this.route.params.subscribe(params => {
      this.getPost(params.id);
      
    })


  }

}



// WEBPACK FOOTER //
// /tmp/build_fdb7fa8d/src/app/video/video.component.ts